module.exports = __webpack_public_path__ + "static/logo-b28bef4395016ff6920b52021973d5e5.svg";